
  <app-header [header-data]="headerData"></app-header>
  <div *ngIf="!isLoading">
  <div class="container">
    <div class="creditor-portal pb-5">
      <div class="row hght100 pb-5">
        <div class="col-md-12 ">
          <div class="card">
            <div class="card-body d-flex flex-column" style="position: relative;">
              <div class="row hght100">
                <div class="col-md-7">
                  <h3>{{broadcastDetails.displayName}}</h3>
                  <h2>{{broadcastDetails.subjectHeader}}</h2>
                  <p class="date-label">{{broadcastDetails.publishDateTime | uppercase}}</p>
                  <div class="description-sec ck-custom-content">
                    <p [innerHTML]="broadcastDetails.content"></p>
                    <p></p>
                  </div>
                  <button class="primary-button bg-transparent back-button ml-4"
                    (click)="navigateToCreditorHome()">HOME</button>
                </div>
                <div class="col-md-5 download-info">
                  <div class="d-flex justify-content-end">
                    <button class="primary-button download bg-transparent button-spacing" *ngIf="showProxyButton"
                      (click)="redirectToProxyForm()">
                      <img src="../../../../assets/images/creditor-portal/Upload-Arrow.svg" alt="Download">
                      Submit Form(s)</button>
                    <button class="primary-button download bg-transparent" *ngIf="originalFiles.length !==0"
                      (click)="downloadAllFiles()">
                      <img src="../../../../assets/images/creditor-portal/download.svg" alt="Download">
                      {{isnotonlyPDF}}</button>
                  </div>
                  <ul>
                    <li [ngClass]="file.extn" *ngFor="let file of originalFiles">
                      <h6><a class="list-inline-item pointer text-dark"
                          (click)="downloadSingleFile(file)">{{file.id}}</a></h6>
                      <label>{{file.fileSize}}</label>
                      <button type="button" (click)="downloadSingleFile(file)" class="download-link d-block">
                        {{file.hyperlink}}
                      </button>

                    </li>
                  </ul>

                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>